import React from 'react'
import logo from '../assets/logowbg.png';
import stalin from '../assets/stalin.jpg';
import tnwclogo from '../assets/tnwclogo.avif';

import wh1 from '../assets/wh1.jpg';
import wh2 from '../assets/wh2.avif';
import wh3 from '../assets/wh3.png';
import wh4 from '../assets/wh4.webp';
import { useEffect, useState } from 'react';
// import './Homepage1.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
import {
    FaPhoneAlt, FaEnvelope, FaMapMarkerAlt,
    FaFacebookF, FaInstagram, FaLinkedinIn
} from "react-icons/fa";

const NAV_TABS = ['Home', 'About', 'Statistics', 'Services',
    'Tenders', 'Documents', 'RTI', 'Gallery', 'Other Links', 'Contact Us'];

const services = [
    {
        icon: 'bi-snow',
        title: 'Cold Storage',
        desc: 'Temperature-controlled storage solutions to preserve agricultural produce and perishable goods.',
        points: [
            'Multi-temperature zones',
            'Reduced post-harvest losses',
            '24/7 monitoring',
            'Quality preservation',
        ],
    },
    {
        icon: 'bi-truck',
        title: 'Logistics Support',
        desc: 'Integrated logistics and transportation services ensuring smooth movement of goods.',
        points: [
            'End-to-end supply chain support',
            'Real-time tracking',
            'Fast distribution network',
            'Trusted logistics partners',
        ],
    },
    {
        icon: 'bi-building',
        title: 'Custom Warehousing',
        desc: 'Flexible and scalable warehousing solutions tailored to business requirements.',
        points: [
            'Custom storage layouts',
            'Bulk & pallet storage',
            'Industry-specific facilities',
            'Cost-effective solutions',
        ],
    },
];

function Hero() {
    const images = [wh1, wh2, wh3];

    useEffect(() => {
        const el = document.getElementById("heroCarousel");
        const carousel = new bootstrap.Carousel(el, {
            interval: 5000,
            ride: "carousel",
            pause: false,
            wrap: true,
        });

        return () => carousel.dispose();
    }, []);

    return (
        <section className="position-relative vh-100 overflow-hidden">

            {/* ================= NAVBAR ================= */}
            <nav className="navbar navbar-expand-lg position-absolute top-0 w-100" style={{ zIndex: 10 }}>
                <div className="container">
                    <a className="navbar-brand text-white fw-bold fs-3">TNWC</a>

                    <ul className="navbar-nav mx-auto gap-4">
                        {NAV_TABS.map(tab => (
                            <li key={tab} className="nav-item nav-link-hover">
                                <span className="nav-link text-white fw-semibold">{tab}</span>
                            </li>
                        ))}
                    </ul>

                    <button className="btn px-4 fw-semibold" style={{color: "white", background: "rgba(9, 26, 58, 1)"}}>Login</button>
                </div>
            </nav>

            {/* ================= CAROUSEL ================= */}
            <div id="heroCarousel" className="carousel slide carousel-fade h-100">
                <div className="carousel-inner h-100">
                    {images.map((img, idx) => (
                        <div key={idx} className={`carousel-item h-100 ${idx === 0 ? "active" : ""}`}>
                            <img
                                src={img}
                                className="w-100 h-100"
                                style={{ objectFit: "cover" }}
                                alt=""
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* ================= DARK OVERLAY ================= */}
            <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ background: "rgba(0,0,0,0.55)", zIndex: 2 }}
            />

            {/* ================= HERO CONTENT ================= */}
            <div
                className="position-absolute top-50 start-50 mt-3 translate-middle text-white px-3"
                style={{ zIndex: 3, maxWidth: "900px" }}
            >
                <div className="mb-3 opacity-75 fs-4">★★★</div>

                <p className="text-uppercase fw-semibold opacity-75 mb-2">
                    We’re Tamil Nadu Warehousing
                </p>

                <h1 className="display-3 fw-bold mb-4 fs-2">
                    Efficient Storage Solutions
                </h1>

                <p className="lead mb-4 fs-5">
                    Supporting agriculture, industries, and logistics with cutting-edge storage facilities.
                </p>

                <div className="d-flex justify-content-center gap-3">
                    <button className="btn btn-lg display-6 "  style={{color: "white", backgroundColor: "rgba(9, 26, 58, 1)"}}>Explore Now</button>
                    <button className="btn btn-outline-light btn-lg px-5">Video Presentation</button>
                </div>
            </div>

            {/* ================= CURVED BOTTOM ================= */}
            <div
                className="position-absolute bottom-0 start-0 w-100"
                style={{ zIndex: 4, lineHeight: 0 }}
            >
                <svg viewBox="0 0 1440 320" preserveAspectRatio="none" style={{ width: "100%", height: "180px" }}>
                    <path
                        d="M0,0 C360,120 1080,120 1440,0 L1440,320 L0,320 Z"
                        fill="#fff"
                    />
                </svg>
            </div>
        </section>
    );
}

export default Hero;
